import ReusableDropdown from "../../../components/ReusableDropdown";

const CompanySelector = ({ t, styles, selectedCompany, setSelectedCompany, companies, companiesLoading, onLoad, language, theme }) => {
  const filtered = (companies || []).filter(
    (c) => String(c?.clientName || "").trim() === String(selectedCompany.client || "").trim() && c?.companyName
  ).map((c) => String(c.companyName).trim());

  return (
    <div style={styles.card}>
      <h3 style={styles.cardTitle}>{t.selectCompany}</h3>
      <div style={styles.gridTwo}>
        <div style={styles.inputGroup}>
          <label style={styles.label}>{t.clientName}</label>
          <div style={{ ...styles.input, display: "flex", alignItems: "center", cursor: "default" }}>
            {selectedCompany.client || (companiesLoading ? t.loadingCompanies : "-")}
          </div>
        </div>
        <div style={styles.inputGroup}>
          <label style={styles.label}>{t.workingCompany}</label>
          <ReusableDropdown
            items={filtered}
            value={selectedCompany.company}
            onChange={() => {}}
            onSelect={(name) => setSelectedCompany((p) => ({ ...p, company: String(name || "").trim() }))}
            placeholder={t.selectCompany2}
            theme={theme} language={language} maxItems={10}
            getItemLabel={(item) => item}
            getItemKey={(item) => item}
            disabled={!selectedCompany.client}
          />
        </div>
      </div>
     
    </div>
  );
};

export default CompanySelector;